import { useDidMount } from '@surveycake/rhooks';
import { PageService, PageType } from 'app/core/page';
import { isInIframe } from 'config/system';

/**
 * For embeded. To listen the message posted by the parent window.
 */
export function usePreviewMessageEvent() {
  const setPage = PageService.useSetPage();

  useDidMount(() => {
    if (isInIframe) {
      const listener = (event: MessageEvent) => {
        const type = event.data && event.data.type;
        const page: PageType = event.data && event.data.payload;

        if (type === 'CHANGE_PAGE') {
          setPage(page);
        }
      };
      window.addEventListener('message', listener);
      return () => window.removeEventListener('message', listener);
    }
  });
}
